export const TEST_ID = 'assetsGridRow';
